<template>
  <div
    class="login-layout bg-gradient h-screen overflow-y-auto"
    :class="{
      'bg-gradient--personal': store.isCurrentTab('personal'),
      'bg-gradient--company': store.isCurrentTab('company'),
    }">
    <div class="container mx-auto py-4">
      <div class="grid grid-cols-12 gap-4">
        <slot name="default"></slot>
      </div>
    </div>
    <ModalsContainer />
    <LangSwitcher :type="'fixed'" />
  </div>
</template>
<script lang="ts" setup>
import { ModalsContainer } from 'vue-final-modal'
import { useStore } from '~/stores/store.js'
import LangSwitcher from '~/components/shared/LangSwitcher.vue'
const store = useStore()
</script>
<style lang="scss" scoped>
@property --bg-color {
  syntax: '<color>';
  initial-value: #3870ff;
  inherits: true;
}
.bg-gradient {
  background: radial-gradient(
    50% 50% at 0% 100%,
    var(--bg-color) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  transition: --bg-color 0.5s;
  &--personal {
    --bg-color: #3870ff;
  }
  &--company {
    --bg-color: #ffa800;
  }
}
</style>
